module.exports = __webpack_public_path__ + "static/media/desktop6.0fef2bd7.png";